import React from 'react';

import './lesson-passport__skeleton.scss';

export const LessonPassportSkeleton = () => {
    return (
        <>
            <div className="lesson-passport__skeleton-item lesson-passport__skeleton-title" />
            <div className="lesson-passport__skeleton-item lesson-passport__skeleton-info " />
            <div className="lesson-passport__skeleton-item lesson-passport__skeleton-info " />
            <div className="lesson-passport__skeleton-wrapper">
                <div className="lesson-passport__skeleton-item lesson-passport__skeleton-block" />
                <div className="lesson-passport__skeleton-item lesson-passport__skeleton-button" />
            </div>
        </>
    );
};
